import { useState } from "react";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react/dist/iconify.js";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Chip, TextField } from "@mui/material";
import "./ForwardMessageModal.css";
import { forwardEmail } from "../Store/Actions/TicketAction";

const ForwardMessageModal = ({ caseID, message, ticketNo, onClose }) => {
  const [address, setAddress] = useState("");
  const [isAddressInvalid, setIsAddressInvalid] = useState(false);
  const [isOpeningNoteEmpty, setIsOpeningNoteEmpty] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [openingNote, setOpeningNote] = useState("");
  const [recipientList, setRecipientList] = useState([]);

  // Modules and formats for React Quill component
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  return (
    <div className="forward-message-modal overlayHistory">
      <div onClick={(e) => e.stopPropagation()} className="modalContainer">
        <div className="modalRight">
          <CloseOutlinedIcon className="closeBtn" onClick={onClose} />

          <div className="content">
            <h1>Forward Message</h1>
          </div>

          <div className="AssignAgentBody">
            <div className="ContainerT1">
              <form
                method="post"
                onSubmit={(e) => {
                  e.preventDefault();

                  if (
                    address.includes("@aladinbank.id") ||
                    address.includes("@moxcal.com")
                  ) {
                    if (!recipientList.includes(address)) {
                      setRecipientList((prevList) => [...prevList, address]);
                    }

                    setAddress("");
                  } else {
                    setIsAddressInvalid(true);
                  }
                }}
              >
                {isOpeningNoteEmpty && (
                  <div className="required-message">
                    <Icon
                      color="#ffb529"
                      icon="ion:warning"
                      width="20"
                      height="20"
                    />

                    <p>Please fill out this field.</p>
                  </div>
                )}

                <ReactQuill
                  className={isOpeningNoteEmpty ? "error" : ""}
                  formats={formats}
                  modules={modules}
                  placeholder="Opening Note"
                  theme="snow"
                  value={openingNote}
                  onChange={(e) => {
                    setOpeningNote(e);
                    setIsOpeningNoteEmpty(false);
                  }}
                />

                <TextField
                  className="search-item status-selector"
                  fullWidth
                  helperText={
                    <>
                      {isAddressInvalid && (
                        <p className="invalid">Invalid email address</p>
                      )}

                      <p>Only aladinbank.id email domain is allowed</p>
                    </>
                  }
                  label="Email Address"
                  type="email"
                  value={address}
                  onChange={(e) => {
                    setIsAddressInvalid(false);
                    setAddress(e.target.value);
                  }}
                />

                <button className="add" disabled={!address}>
                  Add
                </button>
              </form>

              <div className="recipient-list">
                <h4>Recipient List</h4>

                <div className="recipient-chips">
                  {recipientList.map((list) => (
                    <Chip
                      label={list}
                      onDelete={() => {
                        setRecipientList(
                          recipientList.filter(
                            (recipient) => recipient !== list
                          )
                        );
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="btnContainer">
            <button className="btn_Cancel" onClick={onClose}>
              Cancel
            </button>

            <button
              className={"btn_Confirm"}
              disabled={
                isSending || !recipientList.length || isOpeningNoteEmpty
              }
              onClick={() => {
                // check if the opening note is empty
                if (
                  (!openingNote.length || openingNote === "<p><br></p>") &&
                  (!openingNote.length || openingNote === "<p><br></p>")
                ) {
                  setIsOpeningNoteEmpty(true);
                } else {
                  setIsOpeningNoteEmpty(false);
                  setIsSending(true);

                  forwardEmail({
                    caseid: caseID,
                    contactid: 2, // Hardcode channel email
                    description: message.BodyEmail,
                    forwardto: recipientList,
                    openingnote: openingNote,
                    tickethistoryid: message.TicketHistoryID,
                    ticketno: ticketNo,
                    title: message.SubjectEmail,
                  })
                    .then((response) => {
                      if (response.status) {
                        setIsSending(false);
                        setRecipientList([]);

                        toast.success("Message forwarded successfully", {
                          autoClose: 3000,
                        });

                        onClose();
                      } else {
                        console.log("error", response.error);
                        setIsSending(false);

                        toast.error("Failed to forward message", {
                          autoClose: 3000,
                        });
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);
                      setIsSending(false);

                      toast.error("Failed to forward message", {
                        autoClose: 3000,
                      });
                    });
                }
              }}
            >
              {isSending ? "Sending..." : "Send"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForwardMessageModal;
